import React, { useState } from 'react';

import { Box, Tooltip } from '@material-ui/core';

type IconProps = {
  fill?: string;
  width?: number | string;
  height?: number | string;
  action?: () => void;
  style?: any;
};

export function LoanSimulationIcon({ fill: color = '#0370B2', width = 30, height = 30, action, style }: IconProps) {
  const [fill, setFill] = useState<string>(color);

  const handleMouseEnter = () => {
    setFill('#2CB03B');
  };

  const handleMouseLeave = () => {
    setFill(color);
  };

  return (
    <Tooltip title="Simular Empréstimo">
      <Box
        style={{
          width: 50,
          height: 50,
          borderRadius: '50%',
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: fill,
          boxShadow: '0px 4px 4px 0px #00000040',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          ...style,
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={action}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 30 30">
          <path
            fill={fill}
            d="M26.64 0c.938 0 1.72.339 2.344 1.016C29.661 1.64 30 2.422 30 3.359v23.282c0 .937-.338 1.744-1.016 2.422-.625.625-1.406.937-2.343.937H3.359c-.937 0-1.744-.313-2.421-.938C.313 28.386 0 27.578 0 26.642V3.359c0-.937.313-1.718.938-2.343C1.615.339 2.421 0 3.358 0h23.282zm0 26.64v-20H3.36v20h23.28zm-9.14-10c0-.677-.26-1.25-.781-1.718-.469-.521-1.042-.781-1.719-.781s-1.276.26-1.797.78a2.338 2.338 0 00-.703 1.72c0 .729.234 1.328.703 1.797.521.468 1.12.703 1.797.703.677 0 1.25-.235 1.719-.703.52-.47.781-1.068.781-1.797zM15 10c1.51 0 2.917.287 4.219.86a10.942 10.942 0 013.515 2.343c.99.99 1.745 2.136 2.266 3.438a10.995 10.995 0 01-2.266 3.515c-.99.99-2.161 1.771-3.515 2.344-1.302.573-2.709.86-4.219.86-1.51 0-2.943-.287-4.297-.86a11.187 11.187 0 01-3.437-2.344A10.996 10.996 0 015 16.641a10.134 10.134 0 012.266-3.438c.99-.99 2.135-1.77 3.437-2.344A10.915 10.915 0 0115 10zm0 10.86c1.146 0 2.11-.417 2.89-1.25.834-.834 1.25-1.823 1.25-2.97 0-1.145-.416-2.109-1.25-2.89-.78-.833-1.744-1.25-2.89-1.25-1.146 0-2.135.417-2.969 1.25-.781.781-1.172 1.745-1.172 2.89 0 1.146.391 2.136 1.172 2.97.834.833 1.823 1.25 2.969 1.25z"
          ></path>
        </svg>
      </Box>
    </Tooltip>
  );
}
